import { createSelector } from 'reselect';
import { getFileInfoState } from './getFileInfoState';
const selectFileInfoId = (state, id) => id;
export const getFileInfoById = createSelector([getFileInfoState, selectFileInfoId], (fileState, id) => {
    return id && fileState && fileState.byId[id] ? fileState.byId[id] : null;
});
//# sourceMappingURL=getFileInfoById.js.map